import { render } from "./VacancyPage.vue?vue&type=template&id=27559d0e&scoped=true"
import script from "./VacancyPage.vue?vue&type=script&lang=js"
export * from "./VacancyPage.vue?vue&type=script&lang=js"

import "./VacancyPage.vue?vue&type=style&index=0&id=27559d0e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27559d0e"]])

export default __exports__